import { apiMipe, api } from '@/core/api/'

const reportApiUrl = 'api/report'
const codeApiUrl = 'api/code'

export default {
  getFilters(route, properties) {
    return apiMipe.get(`${reportApiUrl}/${route}`, {
      params: {
        ...properties,
      },
    })
  },

  GetReportStudentSearchInitialFilterValues(properties) {
    return api.get(`${reportApiUrl}/initfiltersReportStudent`, {
      params: {
        ...properties,
      },
    })
  },
  GetReportCoordinatedAssessmentsParams(properties) {
    return api.get(`${reportApiUrl}/initfiltersCoordinatedAssessments`, {
      params: {
        ...properties,
      },
    })
  },
  GetReportCommentsTypeParams(properties) {
    return api.get(`${reportApiUrl}/initfiltersCommentsType`, {
      params: {
        ...properties,
      },
    })
  },
  GetStudentRequestLocationParams(properties) {
    return api.get(`${reportApiUrl}/studentrequestlocationparams`, {
      params: {
        ...properties,
      },
    })
  },
  GetBooksPurchaseParams(properties) {
    return api.get(`${reportApiUrl}/initfiltersBooksPurchase`, {
      params: {
        ...properties,
      },
    })
  },
  GetTransportationSmteParams(properties) {
    return api.get(`${reportApiUrl}/initfiltersTransportationSmte`, {
      params: {
        ...properties,
      },
    })
  },
  GetBooksRequestsParams(properties) {
    return api.get(`${reportApiUrl}/initfiltersBooksRequests`, {
      params: {
        ...properties,
      },
    })
  },
  GetTransitionalServicesEvaluationFilters() {
    return api.get(`${reportApiUrl}/initfiltersTransitionalServicesEvaluation`)
  },
  GetTransitionalServicesFilters() {
    return api.get(`${codeApiUrl}/servicetypes`)
  },
  GetTransitionalDisciplineFilters(properties) {
    return api.get(`${codeApiUrl}/disciplinetypes`, {
      params: {
        ...properties,
      },
    })
  },
  GetFederal14IndicatorFilters() {
    return api.get(`${reportApiUrl}/initfiltersFederal14Indicator`)
  },
  GetQuestionnaireStatus() {
    return api.get(`${codeApiUrl}/questionnairestatus`)
  },
  getSchoolTypes() {
    return apiMipe.get(`${codeApiUrl}/getcodebytype?type=LocationTypes`)
  },
  getMonitoringStatuses() {
    return api.get(`${codeApiUrl}/monitoringstatuses`)
  },
  getEdenPersonnelCategoryTypes() {
    return api.get(`${codeApiUrl}/EdenPersonnelCategoryType`)
  },
  getDisciplineTypeServices() {
    return api.get(`${codeApiUrl}/disciplineTypeServices`)
  },
  getAllDisciplineTypes() {
    return api.get(`${codeApiUrl}/alldisciplinetypes`)
  },
  getAllRpDisciplineTypes() {
    return api.get(`${codeApiUrl}/allrpdisciplinetypes`)
  },
  getDisbursementRequestStatuses() {
    return api.get(`${codeApiUrl}/disbursementstatuses`)
  },
  getTapRequestDeterminationTypes() {
    return api.get(`${codeApiUrl}/taprequestdeterminationtypes`)
  },
  getSaee10FiltersAsync() {
    return api.get(`${reportApiUrl}/getsaee10filters`)
  },
  getRegionalOfficeAlternativeLocationAnalisysFilters() {
    return api.get(`${reportApiUrl}/regionalofficealternativelocationanalisys/filters`)
  },
  getAvailableAcademicYearWeeks(academicYearId) {
    return api.get(`${reportApiUrl}/availableacademicyearweeks/${academicYearId}`)
  },
}
